"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _tabTitle = require("./tab-title.style");

var _tags = _interopRequireDefault(require("../../../../utils/helpers/tags/tags"));

var _validationIcon = _interopRequireDefault(require("../../../../__internal__/validations/validation-icon.component"));

var _guid = _interopRequireDefault(require("../../../../utils/helpers/guid"));

var _icon = _interopRequireDefault(require("../../../icon"));

var _events = _interopRequireDefault(require("../../../../utils/helpers/events/events"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const TabTitle = /*#__PURE__*/_react.default.forwardRef(({
  isTabSelected,
  dataTabId,
  title,
  position = "top",
  error,
  warning,
  info,
  size = "default",
  onClick,
  titlePosition = "before",
  siblings,
  errorMessage = "",
  warningMessage = "",
  infoMessage = "",
  borders = false,
  alternateStyling = false,
  noLeftBorder = false,
  noRightBorder = false,
  customLayout,
  isInSidebar,
  href,
  onKeyDown,
  ...tabTitleProps
}, ref) => {
  const keys = (0, _react.useRef)([]);
  const isHref = !!href;
  const hasAlternateStyling = alternateStyling || isInSidebar;
  const hasFailedValidation = error || warning || info;

  if (siblings && !keys.current.length) {
    siblings.forEach(() => keys.current.push((0, _guid.default)()));
  }

  const handleKeyDown = ev => {
    ev.stopPropagation();

    if (href && _events.default.isEnterOrSpaceKey(ev)) {
      return window.open(href, "_blank");
    }

    return onKeyDown(ev);
  };

  const handleClick = ev => {
    ev.preventDefault();
    const customEvent = { ...ev,
      target: { ...ev.target,
        dataset: {
          tabid: dataTabId
        }
      }
    };

    if (href) {
      onClick(customEvent);
      return window.open(href, "_blank");
    }

    return onClick(customEvent);
  };

  const renderContent = () => {
    if (customLayout) {
      return /*#__PURE__*/_react.default.createElement(_tabTitle.StyledLayoutWrapper, {
        hasCustomLayout: true
      }, customLayout);
    }

    if (!siblings) {
      return title;
    }

    const titleText = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: "title"
    }, title);

    const titleSiblings = /*#__PURE__*/_react.default.createElement(_tabTitle.StyledLayoutWrapper, {
      titlePosition: titlePosition,
      key: "title-siblings"
    }, siblings.map((child, index) => {
      const key = child.props.key || keys.current[index];
      return /*#__PURE__*/_react.default.cloneElement(child, { ...child.props,
        onClick: handleClick,
        key
      });
    }));

    return titlePosition === "before" ? [titleText, titleSiblings] : [titleSiblings, titleText];
  };

  return /*#__PURE__*/_react.default.createElement(_tabTitle.StyledTabTitle, _extends({
    ref: ref,
    "aria-selected": isTabSelected,
    "data-element": "select-tab",
    "data-tabid": dataTabId,
    role: "tab",
    position: position,
    isTabSelected: isTabSelected,
    error: error,
    warning: warning,
    info: info,
    size: size,
    noRightBorder: noRightBorder,
    alternateStyling: alternateStyling || isInSidebar,
    borders: borders,
    isInSidebar: isInSidebar
  }, tabTitleProps, (0, _tags.default)("tab-header", tabTitleProps), {
    onKeyDown: handleKeyDown
  }), /*#__PURE__*/_react.default.createElement(_tabTitle.StyledTitleContent, _extends({}, isHref && {
    href,
    target: "_blank",
    as: "a"
  }, {
    error: error,
    warning: warning,
    info: info,
    position: position,
    size: size,
    onClick: handleClick,
    noLeftBorder: noLeftBorder,
    noRightBorder: noRightBorder,
    borders: borders,
    hasSiblings: !!siblings,
    isTabSelected: isTabSelected,
    hasCustomLayout: !!customLayout,
    alternateStyling: hasAlternateStyling
  }), renderContent(), isHref && /*#__PURE__*/_react.default.createElement(_icon.default, {
    type: "link"
  }), /*#__PURE__*/_react.default.createElement(_tabTitle.StyledLayoutWrapper, {
    hasCustomSibling: !!customLayout
  }, error && /*#__PURE__*/_react.default.createElement(_validationIcon.default, {
    onClick: handleClick,
    tooltipPosition: "top",
    error: errorMessage
  }), !error && warning && /*#__PURE__*/_react.default.createElement(_validationIcon.default, {
    onClick: handleClick,
    tooltipPosition: "top",
    warning: warningMessage
  }), !warning && !error && info && /*#__PURE__*/_react.default.createElement(_validationIcon.default, {
    onClick: handleClick,
    tooltipPosition: "top",
    info: infoMessage
  }))), !(hasFailedValidation || hasAlternateStyling) && isTabSelected && /*#__PURE__*/_react.default.createElement(_tabTitle.StyledSelectedIndicator, {
    "data-element": "tab-selected-indicator",
    position: position,
    size: size
  }));
});

TabTitle.propTypes = {
  title: _propTypes.default.string.isRequired,
  isTabSelected: _propTypes.default.bool,
  position: _propTypes.default.oneOf(["top", "left"]),
  className: _propTypes.default.string,
  dataTabId: _propTypes.default.string,
  id: _propTypes.default.string,
  onClick: _propTypes.default.func,
  onKeyDown: _propTypes.default.func,
  tabIndex: _propTypes.default.string,
  error: _propTypes.default.bool,
  warning: _propTypes.default.bool,
  info: _propTypes.default.bool,
  size: _propTypes.default.oneOf(["default", "large"]),
  titlePosition: _propTypes.default.oneOf(["before", "after"]),
  errorMessage: _propTypes.default.string,
  warningMessage: _propTypes.default.string,
  infoMessage: _propTypes.default.string,
  siblings: _propTypes.default.arrayOf(_propTypes.default.node),
  borders: _propTypes.default.bool,
  alternateStyling: _propTypes.default.bool,
  noLeftBorder: _propTypes.default.bool,
  noRightBorder: _propTypes.default.bool,
  customLayout: _propTypes.default.node,
  isInSidebar: _propTypes.default.bool,
  href: _propTypes.default.string
};
var _default = TabTitle;
exports.default = _default;